import { useEffect, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import UserContext from "../contexts/UserContext";
import Utils from "../Utils";
import axios from "axios";

const SSOLogin = (props) => {
  const [activeTab, setActiveTab] = useState("hotelRep");
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const location = useLocation();

  const { authenticate, goSSO, phLogin } = useContext(UserContext);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const errorParam = params.get("error");
    const tokenParam = params.get("token");
    if (errorParam) setError(errorParam);
    if (tokenParam) setToken(tokenParam);
  }, [location.search]);

  useEffect(() => {
    if (token) {
      setLoading(true);
      axios
        .post(Utils.apiUrl("frontend/auth/sso-login"), { token }, Utils.apiHeaders())
        .then((res) => {
          setLoading(false);
          if (res.data && res.data.success) {
            setSuccess("Login successful! Redirecting...");
            Utils.setUserData(res.data);
            // Optionally redirect after a short delay
            setTimeout(() => {
              window.location.href = process.env.PUBLIC_URL + "/hotel-representative-dashboard";
            }, 1500);
          } else {
            setError(res.data?.message || "Login failed");
          }
        })
        .catch((err) => {
          setLoading(false);
          setError(err.message || "Login failed");
        });
    }
  }, [token]);

  return (
    <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-xl loginWrap">
      <div className="block pb-8 content-center">
        <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Marriott Bonvoy" className="logo" />
      </div>
      <h2 className="text-2xl font-bold text-center mb-6">Login</h2>

      {error && <div className="mb-4 p-4 bg-red-100 text-red-700 rounded">{error}</div>}
      {loading && <div className="mb-4 p-4 bg-blue-100 text-blue-700 rounded">Logging in, please wait...</div>}
      {success && <div className="mb-4 p-4 bg-green-100 text-green-700 rounded">{success}</div>}

      <div id="hotelRepTabContent">
        <div className="flex justify-center p-12 bg-gray-100">
          <div aria-readonly className=" bg-gray-300 text-black font-bold py-2 px-4 rounded w-full">
            signing in with Marriott SSO
          </div>
        </div>
      </div>
    </div>
  );
};

export default SSOLogin;
